import { colors } from '@ajaibid/components';
import { css } from '@emotion/css';
import { string } from 'prop-types';
import React from 'react';
import { NavLink } from 'react-router-dom';

const styLink = css`
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;

  color: ${colors.AJAIB_BLUE_5};
`;

function StockCodeLink({ code = '' }) {
  const uppercasedCode = code.toUpperCase();

  const to = code ? `/home/saham/${uppercasedCode}` : null;

  return (
    <NavLink to={to} className={styLink}>
      {uppercasedCode}
    </NavLink>
  );
}

StockCodeLink.propTypes = {
  code: string.isRequired,
};

export default StockCodeLink;
